import React, { useEffect, useMemo, useState } from 'react';

import { Collapsible, CollapsibleContent } from "@shadcn/components/ui/collapsible";
import "../datatables.scss";
import { Input } from '@shadcn/components/ui/input';


import { Card, CardContent as CardBody, CardHeader} from '@shadcn/components/ui/card'
import { Button } from '@shadcn/components/ui/button';
import Select from '@shadcn/components/ui/react-select';
import useQuery from '../../../helpers/JIFI/useQuery';

import { useHistory } from "react-router-dom";
import superagent from 'superagent';
import { backendUrl } from '../../../helpers/consts.js';

import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useUrlState } from '../../../helpers/useUrlState';
import { replaceWithErrorStatus } from '../../../helpers/JIFI/replaceWithErrorStatus';
import '../../Skote/Dashboard/skelton.css';
import ProductVariantSelector from '../helpers/ProductVariantSelector.js';
import { Col } from '@shadcn/components/ui/col';
import { Row } from '@shadcn/components/ui/row';
import { TablePagination } from '@components/supply-chain/TablePagination';
import { DropdownMenu, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuContent } from '@shadcn/components/ui/dropdown-menu';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader} from '@shadcn/components/ui/dialog'
import { toast } from 'react-toastify';



const ProductRow = ({
  lineKey,
  item,
  products, 
  editQuantityRow,
  isStockLoading,
  isStoreOnHandLoading,
  editVariantRow,
  editProductRow,
  maxCount,
  storeOnHand,
  removeRow,
}) => {
  const handleRemoveRow = () => {
    removeRow(lineKey)
  }

  const setSelectedVariant = (a, b) => {
    editProductRow(lineKey, a?.product)
    editVariantRow(lineKey, a?._id, a?.sku, a?.name)
  }
  
  return (
    <Row className="gap-6" style={{ padding: '16px 0' }}>
      <Col md="8" className="sm:w-8/12">
        <ProductVariantSelector
          products={products}
          setSelectedVariant={setSelectedVariant}
          selectedVariant={item}
          hidePersonalisationOptions
        />
      </Col>
      <Col md="3" className="sm:w-3/12">
        <Input style={{ width: '100%', ...(item['quantity'] <= 0 ? { border: '1px solid red' } : {}) }} type="number" value={item['quantity']} onChange={(e) => editQuantityRow(lineKey, e.target.value)} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch', width: '100%', marginTop: 4 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, whiteSpace: 'nowrap' }}>
            <span className={`text-${maxCount > 0 ? 'success' : 'warning'}`}>Available:</span>
            <h5 className={`font-size-13 text-left mb-0 ${!isStockLoading && maxCount !== undefined ? '' : 'placeholder'}`}>
              {!isStockLoading && maxCount !== undefined ? maxCount : ' '}
            </h5>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'center', gap: 10, transform: 'translateX(-8px)', whiteSpace: 'nowrap' }}>
            <span className={`text-${storeOnHand > 0 ? 'success' : 'warning'}`}>Store SOH:</span>
            <h5 className={`font-size-13 text-left mb-0 ${!isStoreOnHandLoading && storeOnHand !== undefined ? '' : 'placeholder'}`}>
              {!isStoreOnHandLoading && storeOnHand !== undefined ? storeOnHand : ' '}
            </h5>
          </div>
        </div>
      </Col>
      <Col xs="1" className="sm:w-1/12">
        <Button onClick={handleRemoveRow} variant="destructive">
          X
        </Button>{' '}
      </Col>
    </Row>
  );
};

const StockInput = ({
  stock,
  setStock,
  productData,
  maxCounts,
  storeOnHand,
  isStockLoading,
  isStoreOnHandLoading,
}) => {
  const handleAddRow = () => {
    const prefillProduct = stock[stock.length - 1]?.product
    let prefillVariant
    if (prefillProduct) {
      prefillVariant = productData.find(val => prefillProduct === val._id)['variants'][0]._id
    }
    const item = {
      product: "",
      variant: "",
      name: "",
      quantity: 0
    };
    setStock(prev => [...prev, item])
  };

  const editProductRow = (id, productId) => {
    setStock(prev => {
      let newList = [...prev]
      newList[id]['product'] = productId
      newList[id]['quantity'] = 0
      const variant = productData.find(val => `${val._id}` === `${productId}`)
      newList[id]['variant'] = variant?.variants[0]?._id
      return newList
    })
  };

  const editVariantRow = (id, val, sku, name) => {
    setStock(prev => {
      let newList = [...prev]
      newList[id]['variant'] = val
      newList[id]['quantity'] = 0
      newList[id]['sku'] = sku
      newList[id]['name'] = name
      return newList
    })
  };

  const editQuantityRow = (id, val) => {
    setStock(prev => {
      let newList = [...prev]

      const variantList = productData.map(product => product.variants).flat()
      const sku = variantList.find(val => `${val._id}` === `${newList[id]['variant']}`).sku
      const maxCount = maxCounts[sku]

      let parsedInput = parseInt(val)
      if (parsedInput > maxCount) {
        parsedInput = maxCount
      }
      if (parsedInput < 0) {
        parsedInput = 0
      }

      newList[id]['quantity'] = parsedInput
      return newList
    })
  };

  const removeRow = (id) => {
    setStock(prev => {
      let newList = prev.filter((_, key) => key !== id)
      return newList
    })
  };

  const products = productData ? productData.map(product => {
    const variants = product.variants
      .filter(variant => {
        return !stock.some(stockItem => stockItem.variant === variant._id);
      })
      .map(variant => {
        return {
          _id: variant._id,
          name: variant.name,
          selected: stock.findIndex(val => val.variant === variant._id), 
          sku: variant.sku,
          product: product._id,
        }
      });

    return {
      name: product.name,
      _id: product._id,
      variants
    }
  }) : [];

  return <>
    <Row>
      <Col xs="8" className="sm:w-8/12">
        Variant
      </Col>
      <Col xs="4" className="sm:w-4/12">
        Quantity
      </Col>
    </Row>
    <br />
    {
      productData && stock.map((stockObjectRow, lineKey) =>
        <ProductRow
          key={lineKey}
          item={stockObjectRow}
          lineKey={lineKey}
          products={products}
          editQuantityRow={editQuantityRow}
          editProductRow={editProductRow}
          editVariantRow={editVariantRow}
          isStockLoading={isStockLoading}
          isStoreOnHandLoading={isStoreOnHandLoading}
          line={productData.find(val => val._id === stock[lineKey]['product'])?.variants.find((val) => `${stockObjectRow?.variant}` === `${val._id}`)}
          maxCount={stockObjectRow?.sku ? maxCounts[stockObjectRow.sku] ?? 0 : undefined}
          storeOnHand={storeOnHand[stockObjectRow?.sku]}
          removeRow={removeRow}
        />
      )
    }
    {
      productData === undefined ?
        <div className="spinner-border text-primary m-1" role="status">
          <span className="sr-only">Loading...</span>
        </div> :
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
          <Button onClick={handleAddRow} variant="primary">
            Add{" "}
          </Button>{" "}
          <span />
        </div>
    }

  </>
}

const DropLine = ({ locationFrom, replenishHistoryObject, lineKey, isOpen, history, refreshReplenishments, updateHistoryOpen }) => {
  const [loading, setLoading] = useState(false)
  const [acceptModal, setAcceptModal] = useState(false)
  const toggleAcceptModal = () => setAcceptModal(prev => !prev)

  const [cancelModal, setCancelModal] = useState(false)
  const toggleCancelModal = () => setCancelModal(prev => !prev)

  

  const [approveLevels, setApproveLevels] = useState(replenishHistoryObject.counts.map(variantCount => [variantCount.variant.sku, variantCount.count.on_hand]))
  useEffect(() => {
    setApproveLevels(replenishHistoryObject.counts.map(variantCount => [variantCount.variant.sku, variantCount.count.on_hand]))
  }, [replenishHistoryObject])
  const updateLevel = (lineKey, value) => {
    if (value > replenishHistoryObject.counts[lineKey].count.on_hand) {
      value = replenishHistoryObject.counts[lineKey].count.on_hand
    }
    if (value < 0) {
      value = 0
    }
    setApproveLevels(prev => {
      let newVal = [...prev]
      newVal[lineKey][1] = value
      return newVal
    })
  }

  const handleAccept = () => {
    const id = replenishHistoryObject._id
    let approvalCount = approveLevels.map(val => ({ sku: val[0], count: val[1] })).filter(val => val.count > 0)

    setLoading(true)
    superagent.post(`${backendUrl}/inventory/approveReplenish/${id}`)
      .send(approvalCount)
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .on('error', (response) => {
        const code = response.status
        setLoading(false)
        replaceWithErrorStatus(history, code);
      })
      .then(response => {
        const code = response.status
        if (code > 400) {
          replaceWithErrorStatus(history, code);
        } else {
          setAcceptModal(false)
          refreshReplenishments()
          setLoading(false)
        }
      }).catch(err => {
        setLoading(false)
        console.log(err)
      });

  }

  const handleCancel = () => {
    const id = replenishHistoryObject._id
    setLoading(true)
    superagent.post(`${backendUrl}/inventory/cancelReplenish/${id}`)
      .send({})
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .on('error', (response) => {
        const code = response.status
        setLoading(false)
        replaceWithErrorStatus(history, code);
      })
      .then(response => {
        const code = response.status
        if (code > 400) {
          replaceWithErrorStatus(history, code);
        } else {
          setCancelModal(false)
          refreshReplenishments()
          setLoading(false)
        }
      }).catch(err => {
        setLoading(false)
        console.log(err)
      });

  }
  return (
    <>
      <div id="accordion">
        <Card className="mb-1">
          <CardHeader onClick={() => updateHistoryOpen(lineKey)} className="p-3 bg-[#f6f6f6]" id="headingOne">
            <h6 className="m-0 font-14">
              <span
                style={{ cursor: "pointer" }} className={replenishHistoryObject.status === 'pending' ? 'text-warning' : 'text-success'}>
                {locationFrom} || Booked:{(new Date(replenishHistoryObject.createdAt)).toDateString()} - {replenishHistoryObject.status.toUpperCase()}{replenishHistoryObject.approvalDate && ` ON: ${(new Date(replenishHistoryObject.approvalDate)).toDateString()}`}
              </span>
            </h6>
          </CardHeader>
          <Collapsible open={isOpen} onOpenChange={() => updateHistoryOpen(lineKey)}>
            <CollapsibleContent>
            <Card  className="pt-6">
              <CardBody>
                {
                  replenishHistoryObject.counts.map(variantCount => <div> {variantCount.count.on_hand} x {variantCount.variant.sku} </div>)
                }
                {
                  replenishHistoryObject.status === 'pending' && (
                    <>
                      {
                        loading === true ? (
                          <div className="d-flex justify-content-center">
                            <div className="spinner-border text-primary m-1" role="status">
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        ) : (
                          <div className='flex flex-row justify-end gap-4'>
                            <Button variant="destructive"  onClick={() => toggleCancelModal()}> Cancel </Button>
                            <Button variant="success" onClick={() => toggleAcceptModal()}> Accept </Button>
                          </div>
                        )
                      }
                    </>
                  )
                }
              </CardBody>
            </Card>
            </CollapsibleContent>
          </Collapsible>
        </Card>
      </div>
      {
        acceptModal && (
          <Dialog open={acceptModal} role="dialog" autoFocus={true} centered={true} className="exampleModal" tabindex="-1" size="lg" onOpenChange={toggleAcceptModal}>
            <DialogContent className="z-[1600] max-h-[80vh] overflow-y-auto min-w-[50vw]">
            <DialogHeader>
              <h3 className='text-[23px] font-medium'>Accept Stock</h3>
            </DialogHeader>
            <DialogDescription>
              {
                approveLevels.map((level, key) => (
                  <Row className="mb-2">
                    <Col xs="4" className="sm:w-4/12">{level[0]}</Col>
                    <Col xs="8" className="sm:w-8/12"><Input style={{ width: '90%', height: '100%' }} type="number" value={level[1]} onChange={(e) => updateLevel(key, e.target.value)} /></Col>
                  </Row>
                ))
              }
            </DialogDescription>
            <DialogFooter>
              <>
                {
                  loading === true ? (
                    <div className="d-flex justify-content-center">
                      <div className="spinner-border text-primary m-1" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Button onClick={handleAccept} variant="destructive" className="btn-lg btn-rounded">
                        Confirm
                      </Button>
                    </>

                  )
                }
              </>

            </DialogFooter>
            </DialogContent>
          </Dialog>
        )
      }
      {
        cancelModal && (
          <Dialog open={cancelModal} role="dialog" autoFocus={true} centered={true} className="exampleModal" tabindex="-1" size="lg" onOpenChange={toggleCancelModal}>
            <DialogContent>
            <DialogHeader>
              <h3>Cancel Replenishment</h3>
            </DialogHeader>
            <DialogDescription>
              Please Note: Contact Operations – This will also need to be Cancelled in EWE – Jerry
            </DialogDescription>
            <DialogFooter>
              <>
                {
                  loading === true ? (
                    <div className="d-flex justify-content-center">
                      <div className="spinner-border text-primary m-1" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      <Button onClick={handleCancel} variant="destructive" className="btn-lg btn-rounded">
                        Confirm
                      </Button>
                    </>

                  )
                }
              </>

            </DialogFooter>
            </DialogContent>
          </Dialog>
        )
      }
      <br /><br />
    </>
  )
}




const ReplenishStockPage = () => {
  const location = useLocation()
  const history = useHistory();
  const [refresh, setRefresh] = useState(true)
  const refreshReplenishments = () => setRefresh(prev => !prev)
  const [update, setUpdate] = useState(true)
  const [loading, setlLoading] = useState(false)
  const [submitError, setSubmitError] = useState('')
  const [showExcelSheet, setShowExcelSheet] = useState(false)       
  const [loadingTopup, setlLoadingTopup] = useState(false)
  const [stockPull, setStockPull] = useState([])
  const positiveStockPull = useMemo(
    () => stockPull.filter(line => Number(line.quantity) > 0),
    [stockPull],
  )

  

  /*
    Pagination
  */
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(10);
  
  /*
    Modal
  */
    const [modal, setModal] = useState(false)
    const [replenishDraftID, setReplenishDraftID] = useState(null)
    const togglemodal = () => {
      setSubmitError('')
      setModal(prev => !prev)
    }

    const [data] = useQuery({
      url: `/product/variant-options`,
      refresh
    });
    const productData = data
  /*

  */

  /*
    Location Selectors
  */


    
  const [bookableLocations, bookableLocationsState] = useQuery({
    url: `/inventory/getBookableLocations`,
    refresh
  });

  const [selectedFromLocationOptions, setSelectedFromLocationOptions] = useState()
  const [selectedToLocationOptions, setSelectedToLocationOptions] = useState()

  const [stateData, setStateData] = useUrlState({
    selectedFromLocation: undefined,
    selectedToLocation: undefined
  });

  useEffect(() => {
    if (location.search === '') {
      setStateData({
        selectedFromLocation: undefined,
        selectedToLocation: undefined
      })
      setUpdate(prev => !prev)
    }
    console.log()
  }, [location.search])

  const {
    selectedFromLocation,
    selectedToLocation
  } = stateData

  const setSelectedFromLocation = (selectedFrom) => {
    setStateData(prev => ({
      ...prev,
      selectedFromLocation: selectedFrom
    }))
  }

  const setSelectedToLocation = (selectedTo) => {
    setStateData(prev => ({
      ...prev,
      selectedToLocation: selectedTo
    }))
  }

  useEffect(() => {
    if (bookableLocations && bookableLocations.length > 0) {
      setSelectedFromLocationOptions(bookableLocations.map(val => ({ label: val.display_name, value: val.name })))
      const hasSelectedWarehouse = bookableLocations.some(location => location.name === selectedFromLocation?.value)
      const selectedWarehouse = bookableLocations.find(location => location.name === selectedFromLocation?.value) || bookableLocations[0]

      if (selectedWarehouse?.stockDropLocations?.length > 0) {
        setSelectedToLocationOptions(selectedWarehouse?.stockDropLocations.map(val => ({ label: val.display_name, value: val.name })))
        const hasSelectedStore = selectedWarehouse.stockDropLocations.some(
          location => location.name === selectedToLocation?.value,
        )

        // Refreshing bookable locations must not clear an otherwise valid
        // 3PL/store selection. Only initialise (or repair) invalid choices.
        if (!hasSelectedWarehouse || !hasSelectedStore) {
          const firstToLocation = selectedWarehouse.stockDropLocations.find(
            location => location.name === selectedToLocation?.value,
          ) || selectedWarehouse.stockDropLocations[0]
          setStateData(prev => ({
            ...prev,
            selectedFromLocation: hasSelectedWarehouse ? prev.selectedFromLocation : {
              label: selectedWarehouse.display_name,
              value: selectedWarehouse.name,
            },
            selectedToLocation: hasSelectedStore ? prev.selectedToLocation : {
              label: firstToLocation.display_name,
              value: firstToLocation.name,
            },
          }))
        }
      }
    }
  }, [bookableLocations, selectedFromLocation?.value, selectedToLocation?.value, update])

  /*
    Stock Counts
  */

  const [stockCount, setStockCount] = useState({})
  const [storeOnHand, setStoreOnHand] = useState({})
  const selectedSkus = useMemo(
    () => [...new Set(stockPull.map(item => item.sku).filter(Boolean))].sort(),
    [stockPull],
  )
  const [stockCountFull, stockCountState] = useQuery({
    url: `/inventory/fetchStockSummary`,
    refresh,
    queryData: {
      location: selectedFromLocation?.value,
    },
    runQuery: !!selectedFromLocation?.value,
  });
  const isStockLoading = stockCountState === 'loading'
  const [storeStockFull, storeStockState] = useQuery({
    url: `/inventory/fetchStockSummary`,
    refresh,
    queryData: {
      location: selectedToLocation?.value,
      skus: selectedSkus.join(','),
    },
    runQuery: !!selectedToLocation?.value && selectedSkus.length > 0,
  });
  const isStoreOnHandLoading = storeStockState === 'loading'

  useEffect(() => {
    let collatedStockCount = {}
    if (stockCountFull) {
      stockCountFull.forEach(stockSummary => {
        // Replenishments must not offer stock owned by active reservations.
        collatedStockCount[stockSummary.sku] = stockSummary.available ?? 0
      })
    }
    setStockCount(collatedStockCount)
  }, [stockCountFull])

  useEffect(() => {
    const collatedStoreOnHand = {}
    if (storeStockFull) {
      storeStockFull.forEach(stockSummary => {
        collatedStoreOnHand[stockSummary.sku] = stockSummary.onHand
      })
    }
    setStoreOnHand(collatedStoreOnHand)
  }, [storeStockFull])

  // Get Replenishment Drafts
  useEffect(() => {
    if (showExcelSheet && selectedToLocation?.value && selectedFromLocation?.value) {
      superagent.get(`${backendUrl}/inventory/getReplenishmentDrafts`)
        .query({
          locationName: selectedToLocation?.value,
          
        })
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')
        .then(response => {
          const res = response.body;
          let items = [];
          
          if (productData && res.editedSkuCounts) {
            
            for (let [sku, counts] of Object.entries(res.editedSkuCounts)) {
            
              let product = productData.find(val => 
                val.variants.find(variant => variant.sku === sku)
              );
              
              if (product) {
                let variant = product.variants.find(variant => variant.sku === sku);
                
                if (variant) {
                  const available = stockCount[sku] || 0;
                  const quantity = Math.min(
                    Math.max(Number(counts.amountCanReceive || 0), 0),
                    available,
                  );
                  if (quantity <= 0) continue;

                  const item = {
                    product: product._id,
                    variant: variant._id,
                    quantity,
                    sku: sku,
                    name: variant.name
                  };
                  items.push(item);
                }
              }
            }
          }
          
          items = items.sort((a, b) => (a.sku < b.sku) ? -1 : (a.sku > b.sku) ? 1 : 0);
          setStockPull(items);
          setReplenishDraftID(res._id)

          
          // let newStockCount = {...stockCount}; 
          // let newOnHand = {...onHand};
          
          // if (res.editedSkuCounts) {
          //   for (let [sku, counts] of Object.entries(res.editedSkuCounts)) {
          //     newStockCount[sku] = counts.eweAvailableStock; 
          //     newOnHand[sku] = counts.hqSkuCount; 
          //   }
          // }
          
          // setStockCount(newStockCount);
          // setOnHand(newOnHand);
        })
        .catch(err => {
          console.error('Error fetching replenishment drafts:', err);
        });
    }
  }, [showExcelSheet, selectedToLocation, selectedFromLocation, productData, stockCount]);

  /*
    Replenish History
  */
  const [historyOpen, setHistoryOpen] = useState([])
  
  const [selectedStatus, setSelectedStatus] = useState('Pending')

  const [replenishHistory, setReplenishHistory] = useQuery({
    url: `/inventory/fetchReplenish`,
    queryData: {
      page,
      perPage,
      location: selectedToLocation?.value,
      status: selectedStatus.toLowerCase()
    },
    refresh,
    runQuery: !!selectedToLocation?.value,
  });
  const replenishHistoryData = replenishHistory

  const updateHistoryOpen = (key) => {
    setHistoryOpen(prev => {
      let newData = [...prev]
      newData[key] = !newData[key]
      return newData
    })
  }
  

  useEffect(() => {
    if (replenishHistoryData) {
      setHistoryOpen(replenishHistoryData.map(val => false))
    }
  }, [replenishHistoryData])






  const handleSubmit = async () => {
    setlLoading(true)
    setSubmitError('')
    const exportData = {
      locationFrom: selectedFromLocation?.value,
      locationTo: selectedToLocation?.value,
      pullStock: positiveStockPull,
    }

    try {
      await superagent.post(`${backendUrl}/inventory/bookReplenishment`)
        .send(exportData)
        .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
        .set('accept', 'json')

      if (replenishDraftID && showExcelSheet) {
        await superagent.post(`${backendUrl}/inventory/changeReplenishmentDraftStatus`)
          .send({
            draftId: replenishDraftID,
            status:'approved'
          })
          .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
          .set('accept', 'json')
      }
      setModal(false)
      setStockPull([])
      refreshReplenishments()
      toast.success('Replenishment booked successfully')
    } catch (err) {
      const message = err?.response?.body?.message || err?.message || 'Failed to book replenishment'
      const displayMessage = Array.isArray(message) ? message.join(', ') : message
      setSubmitError(displayMessage)
      toast.error(displayMessage)
    } finally {
      setlLoading(false)
    }
  }

  const excelSheetSection = (
    showExcelSheet && ( 
      <div className="mb-4 mt-2">
       
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Topup Excel Sheet:</span>
            <a
              href={'https://docs.google.com/spreadsheets/d/1WcWHG1JqsCMpEpTjm9zY1yQKJFBLZwVrI8CEJO2inOU/edit?gid=553547065#gid=553547065'}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-primary hover:text-primary-dark"
            >
              <i className="mdi mdi-file-excel-outline mr-2 text-lg"></i>
              Open Sheet
              <i className="mdi mdi-open-in-new ml-1 text-sm"></i>
            </a>
          </div>
        
    </div>)
  )

  const handleGetTopUp = () => {
    setShowExcelSheet(false)
    setlLoadingTopup(true)
    superagent.post(`${backendUrl}/orders/getTopUp`)
      .send({
        locationToName: selectedToLocation?.value,
        locationFromName: selectedFromLocation?.value,
      })
      .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
      .set('accept', 'json')
      .on('error', (response) => {
        const code = response.status
        replaceWithErrorStatus(history, code);
        setlLoadingTopup(false)
        toast.error('Failed to prefill top-up quantities. Please try again.')
      })
      .then(response => {
        const res = response.body

        let items = []

        for (let topUpLineSku of Object.keys(res)) {
          let count = res[topUpLineSku]

          let product = productData.find(val => (val.variants.find(variant => variant.sku === topUpLineSku) != undefined))
          if (product != undefined) {
            let variant = product.variants.find(variant => variant.sku === topUpLineSku)
            let stockLevel = stockCount[topUpLineSku]
            if (variant != undefined && stockLevel > 0) {
              const item = {
                product: variant.product,
                variant: variant._id,
                quantity: Math.min(Math.max(Number(count || 0), 0), stockLevel),
                sku: topUpLineSku,
                name: variant.name
              };
              items.push(item)
            }
          }
        }

        items = items.sort((a, b) => (a.sku < b.sku) ? -1 : (a.sku > b.sku) ? 1 : 0);

        setStockPull(prev => [...items])
        setlLoadingTopup(false)
      }).catch(err => {
        console.log(err)
        setlLoadingTopup(false)
      });
  }
  const getUrlStateParam = (value) => encodeURIComponent(JSON.stringify(value))

  const getReturnToWarehouseHref = () => {
    const params = new URLSearchParams()

    if (selectedToLocation?.value) {
      params.set('selectedFromLocation', getUrlStateParam({
        label: selectedToLocation.label,
        value: selectedToLocation.value,
      }))
    }

    if (selectedFromLocation?.value) {
      params.set('selectedToLocation', getUrlStateParam({
        label: selectedFromLocation.label,
        value: selectedFromLocation.value,
      }))
    }

    return `/stock/return-to-warehouse${params.toString() ? `?${params.toString()}` : ''}`
  }

  return <div className="page-content">
      <div className="w-full px-3 mx-auto xl:max-w-[85%]">
      {/* store replenishment secions */}
      <div>
        <Row className="mb-2 gap-6 flex-wrap sm:flex-nowrap">
          <Col className={`${stockPull.length > 0 ? 'md:w-8/12' : 'md:w-full'} lg:w-${stockPull.length > 0 ? '8/12' : 'full'} xl:w-${stockPull.length > 0 ? '8/12' : 'full'}`} >
          <div className="pt-3 flex items-center justify-between gap-4 w-full">
                <div className="flex items-center gap-4">
                  <p className='text-[23px] font-medium mb-0'>
                    Store Replenishments
                  </p>
                  <DropdownMenu>
                    <DropdownMenuTrigger
                    href='#'
                    className='card-drop p-3'
                    tag='i'
                    >
                      <i className="mdi mdi-dots-horizontal font-size-18"></i>

                    </DropdownMenuTrigger>

                    <DropdownMenuContent>
                      <DropdownMenuItem onClick={handleGetTopUp} href="#"> Prefill </DropdownMenuItem>
                      <DropdownMenuItem onClick={() => setShowExcelSheet(true)} href="#"> Show Excel sheet </DropdownMenuItem>
                    </DropdownMenuContent>
                  </DropdownMenu>

                </div>
                <a
                  href={getReturnToWarehouseHref()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 border-0 bg-transparent p-0 text-primary font-medium hover:font-semibold"
                >
                  Return to Warehouse
                  <i className="mdi mdi-arrow-right"></i>
                </a>
              </div>
            <Card className="mb-6">
              
              <CardBody>
                
                {excelSheetSection}
                <div className="my-2">
                    <div className='mb-4'> 
                        <label> 3PL: </label>
                        <Select 
                            options={selectedFromLocationOptions}
                            value={selectedFromLocation}
                            onChange={setSelectedFromLocation}
                        />
                    </div>
                    <div className='mb-4'> 
                        <label> Warehouse: </label>
                        <Select 
                            options={selectedToLocationOptions}
                            value={selectedToLocation}
                            onChange={setSelectedToLocation}
                        />
                    </div>
                </div>
                <br />
                {
                  loadingTopup ? (
                    <div className="spinner-border text-primary m-1" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <>
                      <StockInput maxCounts={stockCount} stock={stockPull} setStock={setStockPull} productData={productData} locationFrom={selectedToLocation?.value} storeOnHand={storeOnHand} isStockLoading={isStockLoading} isStoreOnHandLoading={isStoreOnHandLoading} /><div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: 12 }}>
                        <span />
                        {(productData && positiveStockPull.length > 0) && (
                          <Button onClick={togglemodal} variant="primary" className="btn-lg btn-rounded">
                            Submit
                          </Button>
                        )}
                      </div>
                    </>
                  )
                }
              </CardBody>
            </Card>
          </Col>
          {
            stockPull.length > 0 && (
              <Col className={`${stockPull.length > 0 ? 'md:w-4/12' : 'md:w-0'} ${stockPull.length > 0 ? 'lg:w-4/12' : 'lg:w-0'} ${stockPull.length > 0 ? 'xl:w-4/12' : 'xl:w-0'}`}>
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4 pt-6">STOCK SUMMARY</h4>
                    <br />
                    {
                      productData && stockPull.length > 0 && 'Removing:'
                    }
                    {
                      productData && stockPull.sort((a, b) => (a.sku < b.sku) ? -1 : (a.sku > b.sku) ? 1 : 0).map((line, lineKey) => {
                        return <div>  <span className="text-success">+{line['quantity']}</span> x {line['product'] && line['variant'] && productData.find(val => val._id === line['product']).variants.find(val => val._id === line['variant'])?.sku} </div>
                      })
                    }
                  </CardBody>
                </Card>
              </Col>
            )
          }
        </Row>
      </div>


          {/* booked replenishment section */}
      
      <div>
        <Row>
          <Col  className="w-full">
          <Row >
                    <h4 className='text-[23px] font-medium leading-9 py-3' >Booked Replenishments</h4>
                  </Row>
            <Card className="pt-6 mb-6">
              <CardBody>
                <Row>
                  
                  <Col sm="9" className="sm:w-9/12"></Col>
                </Row>
                <Row>
                  <Col sm="12" className="sm:w-full">
                    <div>
                      <div className='mb-4'> 
                          <label> Status: </label>
                          <Select 
                              options={['Pending', 'Approved', 'Cancelled', 'Error'].map(val => ({value: val, label: val}))}
                              value={{value: selectedStatus, label: selectedStatus}}
                              onChange={e => setSelectedStatus(e.value)}
                          />
                      </div>
                    </div>
                  </Col>
                </Row>

                {
                  (setReplenishHistory === 'success' && replenishHistoryData) ? replenishHistoryData.map((replenishHistoryObject, key) => {
                    return (
                      <DropLine locationFrom={selectedToLocation?.value} history={history} refreshReplenishments={refreshReplenishments} updateHistoryOpen={updateHistoryOpen} isOpen={historyOpen[key]} replenishHistoryObject={replenishHistoryObject} lineKey={key} />
                    )
                  }) : (
                    <div className="spinner-border text-primary m-1 mb-6" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  )
                }
                <TablePagination count={100} page={page} setPage={setPage} perPage={perPage} setPerPage={setPerPage} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
    <Dialog open={modal} role="dialog" autoFocus={true} centered={true} className="exampleModal" tabindex="-1" size="lg" onOpenChange={togglemodal}>
      <DialogContent className="z-[1600] max-h-[80vh] overflow-y-auto min-w-[50vw]">
        <h4 className="card-title mb-4">INTERNAL STOCK SUMMARY</h4>
        <p>
          Any stock with 0 booked will not show up in the replenish history.
        </p>
        <br />
        {
          productData && positiveStockPull.map((line, lineKey) => {
            return <div>  <span className={line['quantity'] > 0 ? "text-success" : 'text-danger'}>+{line['quantity']}</span> x {line['product'] && line['variant'] && productData.find(val => val._id === line['product']).variants.find(val => val._id === line['variant'])?.sku} </div>
          })
        }
        {submitError && <div className="mt-4 text-danger">{submitError}</div>}
     
      <DialogFooter>
        {
          loading ? (
            <div className="spinner-border text-primary m-1" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            <Button onClick={handleSubmit} variant="primary" className="btn-lg btn-rounded">
              Confirm
            </Button>
          )
        }
      </DialogFooter>
      </DialogContent>
    </Dialog>
  </div>
}

export default ReplenishStockPage
